<template>
    <v-card elevation="0">
        <v-card-title class="mt-n2">
            <div class="headline">{{$t('app_drawer.feature')}}</div>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.push({name: 'feature-add'})">
                {{$t('feature.create')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col class="pb-8">
                    <v-text-field v-model="search"
                                append-icon="mdi-magnify"
                                :label="$t('search')"
                                single-line
                                hide-details>
                    </v-text-field>
                </v-col>
                <v-col v-show="$vuetify.breakpoint.smAndUp">
                </v-col>
            </v-row>
            
            <v-data-table :headers="headers"
                        :items="features"
                        :search="search">
                <template v-slot:item.createdAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.updatedAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary"
                        @click="$router.push({name: 'feature-edit', params: {featureId:item.id}})">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'FeatureList',
        setup(props, {root}) {
            const {Feature} = root.$FeathersVuex.api;

            const featureParams = computed(() => {
                return {
                    query: {
                        $sort: {}
                    }
                }
            });
            const featureData = useFind({model: Feature, params: featureParams});

            // Data Table
            const search = ref('');
            const headers = ref([
                {text: root.$t('feature.name'), value: 'name'},
                {text: root.$t('feature.feature_id'), value: 'feature_id'},
                {text: root.$t('feature.created_at'), value: 'createdAt', filterable: false},
                {text: root.$t('feature.updated_at'), value: 'updatedAt', filterable: false},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);


            // 4. Return the data, named as you prefer
            return {
                features: featureData.items,

                search,
                headers,

                DateTime,
            }
        }
    }
</script>
